import { all, call, put, takeLatest } from "redux-saga/effects";
import { getErrorMessage } from "utils/sagasErrorHandler";
import {
    getSQSQueuesRequest
} from "modules/Queues/services/Queues/api";
import {
    getSQSQueues,
    getSQSQueuesSuccess,
    getSQSQueuesError,
} from "modules/Queues/services/Queues/actions";
import {QUEUES_ITEMS_PER_PAGE} from "../../constants";

let lastRequestedName = null;
let cachedQueuesResponse = null;

function* handleGetSQSQueues ({ payload = {} }) {
    try {
        const {
            limit = QUEUES_ITEMS_PER_PAGE,
            offset = 0,
            sort_direction = "desc",
            sort_field = "messages",
            name = "",
            refresh_page = false
        } = payload;

        const normalizedName = String(name).toLowerCase().trim();

        let queuesResponse;
        if (cachedQueuesResponse && lastRequestedName === normalizedName && !refresh_page) {
            queuesResponse = cachedQueuesResponse;
        } else {
            queuesResponse = yield call(getSQSQueuesRequest);
            cachedQueuesResponse = queuesResponse;
            lastRequestedName = normalizedName;
        }

        let queues = [...queuesResponse.queues];

        // -----------------------------
        // FILTERING
        // -----------------------------
        if (normalizedName) {
            queues = queues.filter((queue) =>
                queue.name.toLowerCase().includes(normalizedName)
            );
        }

        let total_messages_available = 0;
        let total_messages_in_flight = 0;

        queues.forEach((queue) => {
            total_messages_available += queue.messages_available;
            total_messages_in_flight += queue.messages_in_flight;
        });

        // -----------------------------
        // SORTING
        // -----------------------------
        queues.sort((a, b) => {
            let aValue;
            let bValue;

            switch (sort_field) {
                case "name":
                    aValue = a.name.toLowerCase();
                    bValue = b.name.toLowerCase();
                    break;

                case "total":
                    aValue = a.messages_available + a.messages_in_flight;
                    bValue = b.messages_available + b.messages_in_flight;
                    break;

                case "lag":
                    aValue = a.messages_available;
                    bValue = b.messages_available;
                    break;

                case "in_progress":
                    aValue = a.messages_in_flight;
                    bValue = b.messages_in_flight;
                    break;

                default:
                    aValue = a.name.toLowerCase();
                    bValue = b.name.toLowerCase();
            }

            // string sorting
            if (typeof aValue === "string") {
                return sort_direction === "asc"
                    ? aValue.localeCompare(bValue)
                    : bValue.localeCompare(aValue);
            }

            // number sorting
            return sort_direction === "asc"
                ? aValue - bValue
                : bValue - aValue;
        });

        // -----------------------------
        // PAGINATION
        // -----------------------------
        const paginatedQueues = queues.slice(Number(offset), Number(offset) + Number(limit));

        yield put(getSQSQueuesSuccess({
            queues: paginatedQueues,
            count: queues.length,
            total_messages_available: total_messages_available,
            total_messages_in_flight: total_messages_in_flight,
        }));
    } catch (error) {
        yield put(getSQSQueuesError());
        getErrorMessage(error);
    }
}

// Watchers
export function* queuesEntriesSagas() {
    yield all([
        takeLatest(getSQSQueues, handleGetSQSQueues),
    ]);
}
